import './searchUser.css';
import { useState } from 'react';
import SearchMain from './SearchMain';
import SearchData from './SearchData';
import Close from '../../design/close';
import Massage from '../../design/Massage';


export default function SearchUser ({firstName, lastName, setClose, setNamesMy, numDocket}) {
    const [names, setNames] = useState({});
    const [massage, setMassage] = useState({open: false, text: ''});

    return (<>
        <div className='searchUser'>
            <p> חיפוש </p>
            <Close
            bc='rgb(117, 110, 110)'
            setClose={setClose}
            hc='rgb(117, 110, 110)'
            />

            <div>
                <SearchMain 
                setNames={setNames} 
                setMassage={setMassage}
                firstName={firstName}
                lastName={lastName}
                setClose={setClose}
                />
                <SearchData 
                data={names} 
                setNames={setNamesMy}
                setMassage={setMassage}
                numOfDocket={numDocket}
                setClose={setClose}
                />
            </div>

            {
                massage.open && 
                <Massage
                animation={true}
                text={massage.text}
                setClose={() => setMassage({open: false, text: ''})}
                />
            }
        </div>
    </>)
}